import SearchBusinessResults from "components/global/SearchBusinessResults";

const VCSearchBusinessResults = () => <SearchBusinessResults />

export default VCSearchBusinessResults;
